import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_SURVEY_TEMPLATES = 'GET_SURVEY_TEMPLATES';
export const GET_SURVEY_TEMPLATE = 'GET_SURVEY_TEMPLATE';
export const GET_PAGINATED_SURVEY_TEMPLATES = 'GET_PAGINATED_SURVEY_TEMPLATES';
export const GET_MINIMAL_SURVEY_TEMPLATES = 'GET_MINIMAL_SURVEY_TEMPLATES';
export const CREATE_SURVEY_TEMPLATE = 'CREATE_SURVEY_TEMPLATE';
export const UPDATE_SURVEY_TEMPLATE = 'UPDATE_SURVEY_TEMPLATE';
export const DELETE_SURVEY_TEMPLATES = 'DELETE_SURVEY_TEMPLATES';
export const SET_CURRENT_SURVEY_TEMPLATE = 'SET_CURRENT_SURVEY_TEMPLATE';
export const UNSET_CURRENT_SURVEY_TEMPLATE = 'UNSET_CURRENT_SURVEY_TEMPLATE';

export const CLEAR_SURVEY_TEMPLATE_ERROR = 'CLEAR_SURVEY_TEMPLATE_ERROR';
export const CLEAR_SURVEY_TEMPLATE_STORE = 'CLEAR_SURVEY_TEMPLATE_STORE';

export const TEST_SURVEY_TEMPLATE = 'TEST_SURVEY_TEMPLATE';

// async actions
export const GET_SURVEY_TEMPLATE_TAGS = 'GET_SURVEY_TEMPLATE_TAGS';
export const GETTING_SURVEY_TEMPLATE_TAGS = 'GETTING_SURVEY_TEMPLATE_TAGS';
export const GETTING_SURVEY_TEMPLATE_TAGS_FAILED = 'GETTING_SURVEY_TEMPLATE_TAGS_FAILED';
export const GETTING_SURVEY_TEMPLATE_TAGS_SUCCEEDED = 'GETTING_SURVEY_TEMPLATE_TAGS_SUCCEEDED';

export const GETTING_SURVEY_TEMPLATES = 'GETTING_SURVEY_TEMPLATES';
export const GETTING_SURVEY_TEMPLATES_SUCCEEDED =
  'GETTING_SURVEY_TEMPLATES_SUCCEEDED';
export const GETTING_SURVEY_TEMPLATES_FAILED =
  'GETTING_SURVEY_TEMPLATES_FAILED';

export const GETTING_PAGINATED_SURVEY_TEMPLATES =
  'GETTING_PAGINATED_SURVEY_TEMPLATES';
export const GETTING_PAGINATED_SURVEY_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_SURVEY_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_SURVEY_TEMPLATES_FAILED =
  'GETTING_PAGINATED_SURVEY_TEMPLATES_FAILED';

export const GETTING_MINIMAL_SURVEY_TEMPLATES = 'GETTING_MINIMAL_SURVEY_TEMPLATES';
export const GETTING_MINIMAL_SURVEY_TEMPLATES_SUCCEEDED =
  'GETTING_MINIMAL_SURVEY_TEMPLATES_SUCCEEDED';
export const GETTING_MINIMAL_SURVEY_TEMPLATES_FAILED =
  'GETTING_MINIMAL_SURVEY_TEMPLATES_FAILED';

export const GETTING_SURVEY_TEMPLATE = 'GETTING_SURVEY_TEMPLATE';
export const GETTING_SURVEY_TEMPLATE_SUCCEEDED =
  'GETTING_SURVEY_TEMPLATE_SUCCEEDED';
export const GETTING_SURVEY_TEMPLATE_FAILED = 'GETTING_SURVEY_TEMPLATE_FAILED';

export const CREATING_SURVEY_TEMPLATE = 'CREATING_SURVEY_TEMPLATE';
export const CREATING_SURVEY_TEMPLATE_SUCCEEDED =
  'CREATING_SURVEY_TEMPLATE_SUCCEEDED';
export const CREATING_SURVEY_TEMPLATE_FAILED =
  'CREATING_SURVEY_TEMPLATE_FAILED';

export const UPDATING_SURVEY_TEMPLATE = 'UPDATING_SURVEY_TEMPLATE';
export const UPDATING_SURVEY_TEMPLATE_SUCCEEDED =
  'UPDATING_SURVEY_TEMPLATE_SUCCEEDED';
export const UPDATING_SURVEY_TEMPLATE_FAILED =
  'UPDATING_SURVEY_TEMPLATE_FAILED';

export const DELETING_SURVEY_TEMPLATES = 'DELETING_SURVEY_TEMPLATES';
export const DELETING_SURVEY_TEMPLATES_SUCCEEDED =
  'DELETING_SURVEY_TEMPLATES_SUCCEEDED';
export const DELETING_SURVEY_TEMPLATES_FAILED =
  'DELETING_SURVEY_TEMPLATES_FAILED';

export const TESTING_SURVEY_TEMPLATE = 'TESTING_SURVEY_TEMPLATE';
export const TESTING_SURVEY_TEMPLATE_SUCCEEDED =
  'TESTING_SURVEY_TEMPLATE_SUCCEEDED';
export const TESTING_SURVEY_TEMPLATE_FAILED = 'TESTING_SURVEY_TEMPLATE_FAILED';

export const SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START =
  'SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START';
export const SURVEY_TEMPLATE_AUTO_SAVE_TIMER_END =
  'SURVEY_TEMPLATE_AUTO_SAVE_TIMER_END';

export const SET_COPY_CURRENT_SURVEY_TEMPLATE =
  'SET_COPY_CURRENT_SURVEY_TEMPLATE';

export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const UNSET_NEXT_STEP = 'UNSET_NEXT_STEP';

export const SET_CUSTOMIZED_TEMPLATE = 'SET_CUSTOMIZED_TEMPLATE';
export const UNSET_CUSTOMIZED_TEMPLATE = 'UNSET_CUSTOMIZED_TEMPLATE';

export const UPDATE_SURVEY_TEMPLATE_FILTERS = 'UPDATE_SURVEY_TEMPLATE_FILTERS';
export const RESET_SURVEY_TEMPLATE_FILTERS = 'RESET_SURVEY_TEMPLATE_FILTERS';

export const getSurveyTemplates = createAction(GET_SURVEY_TEMPLATES);

export const getSurveyTemplate = createAction(GET_SURVEY_TEMPLATE);

export const createSurveyTemplate = createAction(CREATE_SURVEY_TEMPLATE);

export const updateSurveyTemplate = createAction(UPDATE_SURVEY_TEMPLATE);

export const deleteSurveyTemplates = createAction(DELETE_SURVEY_TEMPLATES);

export const setCurrentSurveyTemplate = createAction(
  SET_CURRENT_SURVEY_TEMPLATE
);

export const unsetCurrentSurveyTemplate = createAction(
  UNSET_CURRENT_SURVEY_TEMPLATE
);

export const clearSurveyTemplateError = createAction(
  CLEAR_SURVEY_TEMPLATE_ERROR
);

export const clearSurveyTemplateStore = createAction(
  CLEAR_SURVEY_TEMPLATE_STORE
);

export const gettingSurveyTemplates = createAction(GETTING_SURVEY_TEMPLATES);

export const setNextStep = createAction(SET_NEXT_STEP);
export const unsetNextStep = createAction(UNSET_NEXT_STEP);

export const gettingSurveyTemplatesSucceeded = createAction(
  GETTING_SURVEY_TEMPLATES_SUCCEEDED
);

export const gettingSurveyTemplatesFailed = createAction(
  GETTING_SURVEY_TEMPLATES_FAILED
);

export const gettingPaginatedSurveyTemplates = createAction(
  GETTING_PAGINATED_SURVEY_TEMPLATES
);
export const gettingPaginatedSurveyTemplatesSucceeded = createAction(
  GETTING_PAGINATED_SURVEY_TEMPLATES_SUCCEEDED
);
export const gettingPaginatedSurveyTemplatesFailed = createAction(
  GETTING_PAGINATED_SURVEY_TEMPLATES_FAILED
);

export const gettingMinimalSurveyTemplatesSucceeded = createAction(
  GETTING_MINIMAL_SURVEY_TEMPLATES_SUCCEEDED
);

export const gettingMinimalSurveyTemplatesFailed = createAction(
  GETTING_MINIMAL_SURVEY_TEMPLATES_FAILED
);

export const gettingSurveyTemplate = createAction(GETTING_SURVEY_TEMPLATE);

export const gettingSurveyTemplateSucceeded = createAction(
  GETTING_SURVEY_TEMPLATE_SUCCEEDED
);

export const gettingSurveyTemplateFailed = createAction(
  GETTING_SURVEY_TEMPLATE_FAILED
);

export const creatingSurveyTemplate = createAction(CREATING_SURVEY_TEMPLATE);

export const creatingSurveyTemplateSucceeded = createAction(
  CREATING_SURVEY_TEMPLATE_SUCCEEDED
);

export const creatingSurveyTemplateFailed = createAction(
  CREATING_SURVEY_TEMPLATE_FAILED
);

export const updatingSurveyTemplate = createAction(UPDATING_SURVEY_TEMPLATE);

export const updatingSurveyTemplateSucceeded = createAction(
  UPDATING_SURVEY_TEMPLATE_SUCCEEDED
);

export const updatingSurveyTemplateFailed = createAction(
  UPDATING_SURVEY_TEMPLATE_FAILED
);

export const deletingSurveyTemplates = createAction(DELETING_SURVEY_TEMPLATES);

export const deletingSurveyTemplatesSucceeded = createAction(
  DELETING_SURVEY_TEMPLATES_SUCCEEDED
);

export const deletingSurveyTemplatesFailed = createAction(
  DELETING_SURVEY_TEMPLATES_FAILED
);

export const setCopyCurrentSurveyTemplate = createAction(
  SET_COPY_CURRENT_SURVEY_TEMPLATE
);

export const testSurveyTemplate = createAction(TEST_SURVEY_TEMPLATE);

export const testingSurveyTemplate = createAction(TESTING_SURVEY_TEMPLATE);

export const testingSurveyTemplateSucceeded = createAction(
  TESTING_SURVEY_TEMPLATE_SUCCEEDED
);

export const testingSurveyTemplateFailed = createAction(
  TESTING_SURVEY_TEMPLATE_FAILED
);

export const templateAutoSaveTimerStart = createAction(
  SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START
);

export const templateAutoSaveTimerEnd = createAction(
  SURVEY_TEMPLATE_AUTO_SAVE_TIMER_END
);

export const setCustomizedTemplate = createAction(SET_CUSTOMIZED_TEMPLATE);

export const unsetCustomizedTemplate = createAction(UNSET_CUSTOMIZED_TEMPLATE);

export const getPaginatedSurveyTemplates = createAction(
  GET_PAGINATED_SURVEY_TEMPLATES
);

export const getMinimalSurveyTemplates = createAction(GET_MINIMAL_SURVEY_TEMPLATES);

export const gettingMinimalSurveyTemplates = createAction(GETTING_MINIMAL_SURVEY_TEMPLATES);

export const getSurveyTemplateTags = createAction(GET_SURVEY_TEMPLATE_TAGS);
export const gettingSurveyTemplateTags = createAction(GETTING_SURVEY_TEMPLATE_TAGS);
export const gettingSurveyTemplateTagsSucceeded = createAction(GETTING_SURVEY_TEMPLATE_TAGS_SUCCEEDED);
export const gettingSurveyTemplateTagsFailed = createAction(GETTING_SURVEY_TEMPLATE_TAGS_FAILED);

export const updateSurveyTemplateFilters = createAction(UPDATE_SURVEY_TEMPLATE_FILTERS);
export const resetSurveyTemplateFilters = createAction(RESET_SURVEY_TEMPLATE_FILTERS);